module.exports = __webpack_public_path__ + "static/media/aw.76fe9474.svg";